import { ColumnName } from "../import/column-name";
import { AggregationMethod } from "../preaggregation/aggregation-method";
import { DimensionValue } from "../project/cards/dimension-value";
import { ForecastAdjustmentViewItem } from "./forecast-adjustment-view-item";

export class BenchmarkDiagramPoint {
    public value: number;
    public originalValue: number;
    public controlValue: string;
    public xPos: number;
    public isSelectedAsForecast: boolean;
    public isAdjustable: boolean;
    
    x: number;
    y: number;
    editing: boolean;
    canBeDeleted: boolean;
    showArrows: boolean;
}

export class BandTetragon {
    public leftX: number;
    public rightX: number;
    public topLeftY: number;
    public topRightY: number;
    public bottomLeftY: number;
    public bottomRightY: number;

    public linearLeftY: number;
    public linearRightY: number;
}

export class BenchmarkDiagramSeries {
    public name: string;
    public forecastNameSuffix: string;
    public isAdjustedForecast: boolean;
    public color: string;
    public adjColor: string;
    public points: BenchmarkDiagramPoint[];
    public bandTetragon: BandTetragon;
    public bandTetragonStr: string;

    //for diagrams in cards
    public minVal: number;
    public maxVal: number;
    public oldControlValX: number;
    public oldControlValY: number;
    public newControlValX: number;
    public newControlValY: number;
}

export class DriverTypeForecastAdjustmentViewItem {
    public formulaComponentIndex: number;
    public driverTypeName: string;
    public formulaComponentAdjustment: number;
    public formCompAdjFromPreviousTabs: number;
    public formCompAdjFromThisTab: number;
    public outcomeImpactFromPreviousTabs: number;
    public outcomeImpactFromThisTab: number;
    public outcomeImpact: number;
}

export class BenchmarkDriverTypeSideView {
    public formulaComponents: DriverTypeForecastAdjustmentViewItem[];
    public thisDimensionsComboOutcomeImpact: number;
}

export enum FcstAdjStrategy {
    Set,
    Scale,
}

export class BenchmarksModel {
    public driverId: string;
    public driverTypeName: string;
    public displayDimensionValues: DimensionValue[];
    public diagramSeriesSeq: BenchmarkDiagramSeries[];
    public diagramSeriesTot: BenchmarkDiagramSeries[];
    public diagramSeriesWithoutAdjusted: BenchmarkDiagramSeries[];
    public isForecastAdjustmentValidated: boolean;
    public allControlValues: string[];
    public aggregationMethods: AggregationMethod[];
    public outcomeName: string;
    public formulaComponentNames: string[];
    public numericalColumns: ColumnName[];
    public forecastAdjustments: ForecastAdjustmentViewItem[];
    public undoAvailable: boolean;
    public redoAvailable: boolean;
    public sideView: BenchmarkDriverTypeSideView
    public oldControlValue: string;
    public newControlValue: string;
    public haveDifferentMults: boolean;
    public canAddCard: boolean;
}